import * as React from 'react';
import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Store } from './types';
import { selectTable } from './actions/Actions';

const AllTables: React.FC<RouteComponentProps> = () => {
    const [selectedTableId, setSelectedTableId] = React.useState<number>(null);

    const tables = useSelector(({ app }: Store) => app.tables);
    const dispatch = useDispatch();

    const handleTableSelect = React.useCallback(
        (tableId: number) => () => {
            setSelectedTableId(tableId);

            dispatch(selectTable(tableId));
        },
        [dispatch]
    );

    return (
        <div className='all-tables'>
            <div className='tables'>
                {tables.map(({ code, id, occupied }) => (
                    <div
                        className={classnames('table', {
                            selected: id === selectedTableId,
                            occupied
                        })}
                        key={id}
                        onClick={handleTableSelect(id)}>
                        T-{code}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AllTables;
